import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { HrFormCheckboxComponent } from './hr-form-checkbox.component';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimengSharedModule } from '@hvlng/framework-core/shared';
import { UiSharedModule } from 'ui-shared';

@NgModule({
    declarations: [HrFormCheckboxComponent],
    imports: [
        CommonModule,
        ToolbarModule,
        ButtonModule,
        TranslateModule,
        HvlFormItemModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        PrimengSharedModule,
        UiSharedModule,
    ],
    exports: [HrFormCheckboxComponent],
})
export class HrFormCheckboxModule {}
